import CoreFlexibleList from './CoreFlexibleList';

export { type CoreFlexibleListProps } from './CoreFlexibleList';
export default CoreFlexibleList;
